// Single source of truth for the public contact number. Stored as bare digits
// (country code + subscriber) because that is the shape wa.me/ requires.
const whatsappNumber = import.meta.env.VITE_PUBLIC_WHATSAPP_NUMBER || '919901106601'

// '919901106601' -> '+91 99011 06601'. Anything that isn't the 12-digit India
// shape degrades to a plain '+' prefix rather than mangling the grouping.
const formatPhone = (digits) =>
  /^91\d{10}$/.test(digits)
    ? `+91 ${digits.slice(2, 7)} ${digits.slice(7)}`
    : `+${digits}`

export const env = {
  apiUrl: import.meta.env.VITE_API_URL || '/api',
  appName: import.meta.env.VITE_APP_NAME || 'Deoriginlabs',
  appEnv: import.meta.env.VITE_APP_ENV || 'development',
  enableAnalytics: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
  enableConsoleLogs: import.meta.env.VITE_ENABLE_CONSOLE_LOGS === 'true',
  whatsappNumber,
  phoneDisplay: formatPhone(whatsappNumber),
  phoneHref: `tel:+${whatsappNumber}`,
  supportEmail: import.meta.env.VITE_PUBLIC_SUPPORT_EMAIL || 'contact@deoriginlabs.com',
  telegramUrl: import.meta.env.VITE_PUBLIC_TELEGRAM_URL || 'https://t.me/deoriginlabs',
  messengerUrl: import.meta.env.VITE_PUBLIC_MESSENGER_URL || 'https://m.me/deoriginlabs',
  linkedinUrl: import.meta.env.VITE_PUBLIC_LINKEDIN_URL || 'https://linkedin.com/company/deoriginlabs',
  instagramUrl: import.meta.env.VITE_PUBLIC_INSTAGRAM_URL || 'https://instagram.com/deoriginlabs',
  youtubeUrl: import.meta.env.VITE_PUBLIC_YOUTUBE_URL || 'https://youtube.com/@deoriginlabs',
  heroVideoUrl: import.meta.env.VITE_PUBLIC_HERO_VIDEO_URL || '/videos/devops-hero.mp4',
  siteUrl: import.meta.env.VITE_PUBLIC_SITE_URL || 'http://localhost:3000',
}

export default env
